import React, { useEffect, useRef } from "react";
import { useHistory, useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { Box, Grid } from "@mui/material";

import OutletCoverImage from "@components/outlet-cover-image";
import OutletDetail from "@components/outlet-detail";
import Menu from "@components/menu";
import Loading from "@components/loading";
import ItemDetailDialog from "@components/item-detail-dialog";
import FloatingButton from "@components/floating-button";
import Categories from "@components/categories";
import OutletUnavailableDialog from "@components/outlet-unavaliable-dialog";

import { getOutlet } from "@store/outlet/api";
import { getMenu } from "@store/menu/api";
import { reset } from "@store/resetAPI";
import { actions as OrderActions } from "@store/order/reducer";
import { setOutletId, getOutletId } from "@services/LocalStorageService";
import { defaultTableNumber } from "@services/LocalStorageService";
import { useInView } from "react-intersection-observer";

import { checkValidOrderType, observerConfig } from "./constants";

import "./styles.css";
import { action as UiActions } from "@store/ui/reducer";

function MenuPage(props) {
  const dispatch = useDispatch();

  const { menu, selectedTab } = useSelector((state) => state.menu);

  const selectedCategory = menu?.categories[selectedTab];

  const trackScroll = () => {
    const { top } = document.getElementById("sticky").getBoundingClientRect();
    if (top <= 0) {
      document
        .getElementById("menu-container-2")
        .classList.add("sticky-overflow");
    } else {
      document
        .getElementById("menu-container-2")
        .classList.remove("sticky-overflow");
    }
  };

  // const { position, divRef } = useDivPosition();
  // console.log({ position });
  const { isLoading, error } = useSelector((state) => state.outlet);
  const { isMenuPageLoading } = useSelector((state) => state.ui);
  const { ref, inView } = useInView(observerConfig);
  const { items: itemSelectedForOrder = {} } = useSelector(
    (state) => state.order
  );
  const prevOutletId = getOutletId();

  const { outletId, orderType, locationId } = useParams();
  const history = useHistory();

  const resetStore = () => {
    //console.log(!Boolean(prevOutletId), prevOutletId);
    if (!Boolean(prevOutletId)) {
      setOutletId(outletId);
      return;
    }
    if (prevOutletId !== outletId) {
      dispatch(reset());
    }
  };

  useEffect(() => {
    resetStore();
    if (outletId && orderType) {
      dispatch(getOutlet({ outletId })).then(
        checkValidOrderType(history, orderType)
      );
      dispatch(getMenu({ outletId }));
    }
  }, []);

  useEffect(() => {
    if (!!prevOutletId && !!outletId && prevOutletId !== outletId) {
      localStorage.removeItem("outletId");
      dispatch(OrderActions.updateOrderFor(defaultTableNumber));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [prevOutletId, outletId]);

  useEffect(() => {
    console.log("ichanged");
    dispatch(UiActions.toggleStickyHeader(!inView));
    // if()
  }, [inView]);

  const orderItemLength = Object.values(itemSelectedForOrder).length;
  const goToViewOrder = () => {
    let location = `/view-order/outlet/${outletId}/order-type/${orderType}`;

    if (locationId) {
      location += `/location/${locationId}`;
    }

    history.push(location);
  };

  if (isLoading || isMenuPageLoading) {
    return <Loading />;
  }

  if (error) {
    return null;
  }

  const deviceHeight = document
    .querySelector("body")
    .getBoundingClientRect().height;

  console.log("Into to Menu page", !selectedCategory);

  return (
    <Grid
      container
      id="menu-container"
      height={selectedCategory ? "100vh" : ""}
      overflowY="scroll"
      onScroll={(e) => trackScroll()}
    >
      <Grid item xs={12}>
        <OutletCoverImage />
      </Grid>
      <Grid item xs={12} className="sticky" id="sticky">
        <Box sx={{ backgroundColor: "#fff", width: "100%" }}>
          <OutletDetail />
          <Categories />
          <Menu />
        </Box>
        {/* <Menu /> */}
      </Grid>
      <ItemDetailDialog />
      {Boolean(orderItemLength) && (
        <FloatingButton onClick={goToViewOrder}>
          {orderItemLength} View Order
        </FloatingButton>
      )}
      <OutletUnavailableDialog />
    </Grid>
  );
}

MenuPage.propTypes = {};

export default MenuPage;
